import { getRequest, postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';

export const authentication = async (token: string) => {
  return await postRequest(LocateService, '/auth', { token });
};

export const logout = async () => {
  return await getRequest(LocateService, '/logout');
};

export const verifyInviteToken = async (token: string) => {
  return await postRequest(LocateService, '/welcome', { token });
};
